/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconSelectFilled8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectFilled8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 0a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm1.854 3.354a.5.5 0 1 0-.708-.708L3.5 4.293l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0Zm2.78 5.03a.75.75 0 0 0-1.06-1.06L5.25 6.44l-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3-3Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm3.707 6.707a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectFilled20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectFilled20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10Zm-4.836-4.247a1 1 0 0 0-1.411.083L8.486 11.76 6.235 9.32a1 1 0 0 0-1.47 1.357l2.626 2.845a1.5 1.5 0 0 0 2.12.085l.053-.052a2.23 2.23 0 0 0 .05-.054l5.633-6.338a1 1 0 0 0-.083-1.411Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-4.836-4.247a1 1 0 0 0-1.411.083l-5.267 5.925-2.251-2.44a1 1 0 0 0-1.47 1.357l2.626 2.845a1.5 1.5 0 0 0 2.12.085l.053-.052a2.27 2.27 0 0 0 .05-.054l5.633-6.338a1 1 0 0 0-.083-1.411Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconSelectFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconSelectFilled8 {...iconProps} />;
        case '12':
            return <IconSelectFilled12 {...iconProps} />;
        case '16':
            return <IconSelectFilled16 {...iconProps} />;
        case '20':
            return <IconSelectFilled20 {...iconProps} />;
        case '24':
            return <IconSelectFilled24 {...iconProps} />;
        default:
            return <IconSelectFilled24 {...iconProps} />;
    }
});
